module.exports = __webpack_public_path__ + "static/media/24.3b00bde3.jpg";